export default "__VITE_ASSET__CZ9qpLna__"